@if (viewModel$ | async; as viewModel) {
    <div
        class="combo-bet-linear__content"
        [ngClass]="{
            'combo-bet-linear__content--reward': viewModel.isRewardSelectorVisible,
            'combo-bet-linear__content--error': viewModel.isErrorVisible,
            'combo-bet-linear__content--details': viewModel.showDetailsSection,
            'combo-bet-linear__content--expandable': viewModel.isPickAreaExpandable,
        }">
        <div class="combo-bet-linear__title-container">
            @if (viewModel.showRemoveButton) {
                <bs-digital-pick-remove-button [removeButtonStyle]="removeButtonStyle" (remove)="remove()" />
            }
            <div class="combo-bet-linear__title-column">
                <div class="combo-bet-linear-badge-title-container">
                    @if (viewModel.multiTitleBadge === sgpBadgeTypeEnum.Sgp) {
                        <ms-sgp-badge />
                    } @else if (viewModel.multiTitleBadge === sgpBadgeTypeEnum.SgpPlus) {
                        <ms-sgp-plus-badge />
                    }
                    <span class="combo-bet-linear__title">
                        {{ viewModel.multiTitle }}
                        @if (viewModel.showInfoIcon) {
                            <i class="info-icon theme-info" (click)="toggleInfoMessage($event, viewModel.infoTrackingContext, viewModel.slipId)"></i>
                        }
                    </span>
                </div>
                @if (viewModel.subTitle) {
                    <div class="sub-title-container">
                        @if (viewModel.showBetbuilderLiveIndicator && !isBadgeIndicator) {
                            <i class="live-icon live-red-dot"></i>
                        }
                        <span class="combo-bet-linear__sub-title"> {{ viewModel.subTitle }}</span>
                    </div>
                    @if (viewModel.showBetbuilderLiveIndicator && isBadgeIndicator) {
                        <span class="betslip-digital-pick__live-badge">{{ messages.live }}</span>
                    }
                }
                @if (viewModel.showEachWayToggle) {
                    <bs-linear-eachway-price-button [isToggled]="viewModel.isEachWay" (toggleEachWay)="toggleEachWay($event)" />
                }
                @if (!viewModel.isEpcotEnabled && viewModel.showTokenSummaryUnderTitle) {
                    <bs-digital-token-summary-container [tokenContext]="viewModel.tokenContext" />
                }
            </div>
            <bs-info-message-container [messageId]="getInfoMessageId(viewModel.slipId)">
                <ng-container
                    *ngTemplateOutlet="
                        infoMessageTemplate;
                        context: {
                            close: getCloseInfoMessageFunc(viewModel.slipId),
                            infoMessage: viewModel.infoMessage,
                            infoHeaderTitle: viewModel.infoHeaderTitle,
                            infoHeader: viewModel.infoHeader,
                        }
                    " />
            </bs-info-message-container>
        </div>

        @if (detailsTemplate && viewModel.showDetailsSection) {
            <div class="combo-bet-linear__details-section">
                <ng-container [ngTemplateOutlet]="detailsTemplate" />
            </div>
        }

        @if (viewModel.isPickAreaExpandable) {
            <bs-combo-bet-linear-edit-toggle
                [expanded]="expanded"
                [isEpcotEnabled]="viewModel.isEpcotEnabled"
                [selectedPicksCount]="viewModel.placeablePicksCount"
                [totalPicksCount]="viewModel.totalPicksCount"
                (expandToggled)="toggleExpand()" />
        }

        <div class="combo-bet-linear__multi-summary">
            <bs-linear-container-summary
                [showOdds]="true"
                [oddsDisplayFormat]="oddsDisplayFormat"
                [msAutomation]="'Combo'"
                [indicateOddsChange]="viewModel.isTotalOddsIndicatorEnabled" />
        </div>

        <div class="combo-bet-linear__rewards">
            @if (!viewModel.isEpcotEnabled && !viewModel.showTokenSummaryUnderTitle) {
                <bs-digital-token-summary-container [tokenContext]="viewModel.tokenContext" />
            }
            <bs-reward-tokens-selector-container [tokenContext]="viewModel.tokenContext" />
        </div>

        <div class="combo-bet-linear__errors">
            <bs-linear-combo-bet-container-errors
                [betslipType]="viewModel.betslipType"
                [hasComboPrevention]="viewModel.hasComboPrevention"
                [errors]="viewModel.errors" />
        </div>

        @if (viewModel.isPickAreaExpandable && expanded) {
            <div class="combo-bet-linear__picks-section">
                @if (viewModel.showSelectionCounter) {
                    <div class="combo-bet-linear__picks-amount">
                        <span>{{ selectedPicksCountText(viewModel.placeablePicksCount) }}</span>
                    </div>
                }
                <div class="combo-bet-linear__picks-list">
                    <ng-container [ngTemplateOutlet]="picksTemplate" />
                </div>
            </div>
        }
    </div>
}
